<template>
  <div class="services">
		<div class="title"> Our Store </div>

		<div class="desktop">
			<h3>
				<b>Visit us at <br>
					<span>台北市</span> 106
					<span>大安區信義路四段</span>6<span>號</span>11<span>樓</span>-6<br>
					<span class="englishAddress"> 11F.-6, No.6, Sec. 4, Sinyi Rd., Da’an Dist., Taipei City 106, Taiwan </span>
					<br>
					Salon (11F.-6): +886-2-2706-8086<br>
				</b>
			</h3>
		</div>

		<div class="mobile">
			<h4>
				<b>Visit us at <br>
					<span>台北市</span> 106
					<span>大安區信義路四段</span>6<span>號</span>11<span>樓</span>-6<br>
					<span class="englishAddress"> 11F.-6, No.6, Sec. 4, Sinyi Rd., Da’an Dist., <br>Taipei City 106, Taiwan </span>
					<br>
					Salon (11F.-6): +886-2-2706-8086<br>
				</b>
			</h4>
		</div>

		<div id="sect3">

			<div class="column tallImg">
				<img src="@/assets/images/store_photos/desk&lamps.jpg" />
			</div>
			<div class="column wideImg">
				<img src="@/assets/images/store_photos/sign.jpg" />
				<img src="@/assets/images/store_photos/sofa.jpg" />
			</div>
			<div class="column tallImg">
				<img src="@/assets/images/store_photos/hallway.jpg" />
			</div>
		</div>



		<div class="title"> Services </div>
    <div class="course_menu_group">
			<div class="serviceTypeWrapper">
				<ul v-for="serviceType in serviceTypes" :key="serviceType.id">
					<li>
						<img :src="getCategoryUrl(serviceType)" />
					</li>
					<li v-for="service in getServicesOfType(serviceType)" :key="service.id">
						<button @click="setPosterOnDisplay(service.name)">
							<img :src="getCourseUrl(service.name)" />
						</button>
					</li>
				</ul>
			</div>
		</div>

		<!-- <div id="services_posters"> -->
		<!--   <img :src="getPosterUrl" /> -->
		<!-- </div> -->
  </div>
</template>

<script>
import Styles from "./styles.scss";
import { mapState } from "vuex";

export default {
  name: "Salon",
  data() {
    return {
      posterOnDisplay: "default",
      Styles,
    };
  },
  methods: {
    setPosterOnDisplay(name) {
      this.posterOnDisplay = name;
    },
    getCategoryUrl(category) {
      return require(`@/assets/images/services/categories/${category}.png`);
    },
    getCourseUrl(course) {
      return require(`@/assets/images/services/course_titles/${course}_course.png`);
    },
    getServicesOfType(serviceType) {
      return this.$store.getters.["services/getServicesOfType"](serviceType);
    },
  },
  computed: {
    ...mapState('services', ['serviceList', 'serviceTypes']),
    getPosterUrl() {
      return require(`@/assets/images/services/content/${this.posterOnDisplay}_course_content.png`);
    },
  },
};
</script>
